import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity4 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_4;
}

export default CobbledRoadTileEntity4;
